Auth = require 'db/auth'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Organization = undefined
queueRequire -> Organization = require 'models/organization'
OrganizationAccountView = undefined
queueRequire -> OrganizationAccountView = require 'views/organization/organization-account-view'
OrganizationBillingView = undefined
queueRequire -> OrganizationBillingView = require 'views/organization/organization-billing-view'
OrganizationBoardsView = undefined
queueRequire -> OrganizationBoardsView = require 'views/organization/organization-boards-view'
OrganizationExportView = undefined
queueRequire -> OrganizationExportView = require 'views/organization/organization-export-view'
OrganizationMembersView = undefined
queueRequire -> OrganizationMembersView = require 'views/organization/organization-members-view'
$ = require 'jquery'
log = require 'debug/log'
_ = require 'underscore'
f = require 'effing'
Promise = require 'bluebird'
ninvoke = require 'lib/util/ninvoke'
ApiError = require 'network/api-error'
xtend = require 'xtend'

module.exports =
  routes: [
    ['org/:id', 'organizationById']
    [':name/members', 'organizationMembersView']
    [':name/:username/cards', 'organizationMemberCardsView']
    [':name/export', 'organizationExportView']
  ]

  organizationBoardsView: (orgname) ->
    @displayOrganizationPage
      orgname: orgname
      loadFn: 'loadOrganizationBoardsData'
      additionalFns:
        members: 'loadOrganizationMemberGhost'
      viewClass: OrganizationBoardsView
      getLocation: @getOrganizationUrl
    .done()

  organizationMembersView: (orgname) ->
    @displayOrganizationPage
      orgname: orgname
      loadFn: 'loadOrganizationMembersData'
      viewClass: OrganizationMembersView
      additionalFns:
        organization: 'loadOrganizationMembersExtraData'
      getLocation: @getOrganizationMembersUrl
    .done()

  organizationMemberCardsView: (orgname, username) ->
    # This now lives on the member cards page
    @navigate(@getOrganizationMemberCardsUrl(orgname, username), { trigger: true })

  organizationAccountView: (orgname) ->
    @displayOrganizationPage
      orgname: orgname
      loadFn: 'loadOrganizationData'
      viewClass: OrganizationAccountView
      getLocation: @getOrganizationAccountUrl
      membersOnly: true
    .done()

  organizationExportView: (orgname) ->
    @displayOrganizationPage
      orgname: orgname
      loadFn: 'loadOrganizationExportData'
      viewClass: OrganizationExportView
      getLocation: @getOrganizationExportUrl
      adminOnly: true
    .done()

  organizationBillingView: (orgname, options = {}) ->
    @displayOrganizationPage
      orgname: orgname
      loadFn: 'loadOrganizationData'
      viewClass: OrganizationBillingView
      getLocation: @getOrganizationBillingUrl
      urlOptions: { returnUrl: options.returnUrl }
    .done()

  displayOrganizationPage: (settings) ->
    { orgname, username, product, urlOptions } = settings

    log('controller', ['organization'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', settings.loadFn, orgname
      .tap (org) ->
        Promise.all _.values(settings.additionalFns ? {}).map (methodName) ->
          ModelLoader[methodName] org.id, username
      .then (organization) =>
        member = ModelCache.findOne(Member, 'username', username)

        if (!organization.owned() && settings.adminOnly) ||
            (!organization.isMember(Auth.me()) && settings.membersOnly) ||
            (settings.businessClass? && !organization.isFeatureEnabled(settings.businessClass))
          @organizationBoardsView(orgname)
          return organization

        @clearPreviousView()

        @setViewType(organization)

        options = { urlOptions }

        if member
          options.member = member

        if product?
          options.product = product

        options.modelCache = @getCurrentModelCache()

        organizationView = @topLevelView(settings.viewClass, organization, options)
        @showHeader()

        $('body').addClass('body-tabbed-page')
        $('#content').html(organizationView.render().el)
        @focusContent()

        title = "#{organization.get('displayName')} (#{organization.get('name')})"

        loc = settings.getLocation.apply @, if member
          [organization.get('name'), member.get('username'), urlOptions]
        else if product
          [organization.get('name'), product, urlOptions]
        else
          [organization.get('name'), urlOptions]

        @setLocation
          title: title,
          location: loc

        return organization
      .catch ApiError.Unconfirmed, =>
        ninvoke ModelCache, 'waitFor', 'Member', Auth.myId()
        .then =>
          @displayErrorPage _.extend
            errorType: 'unconfirmedOrgNotFound'
          , Auth.me().toJSON()
      .catch ApiError, =>
        @displayErrorPage()



// WEBPACK FOOTER //
// ./app/scripts/controller/organization-routes.coffee